module.exports = __webpack_public_path__ + "img/DE00480.8a8a3b56.png";